import { styled } from 'linaria/react';
import { css } from 'linaria';
import { breakpoints } from 'common/styles/breakpoints';

export const StmLogoContainer = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 126px;
  padding: var(--space-325);
  margin-bottom: 12px;
  border-radius: var(--rounding-m);
  box-shadow: var(--box-shadow-s);
  object-fit: contain;
  ${breakpoints.only.tablet} {
    height: 141px;
  }
  ${breakpoints.only.desktop} {
    height: 130px;
  }
  ${breakpoints.from.largeDesktop} {
    height: 120px;
  }
`;

export const stmLogoImg = css`
  width: fit-content;
  max-width: 100%;
  height: fit-content;
  max-height: 100%;
  aspect-ratio: inherit;
`;
